/* Complete the Room — client-side palette, anonymous paint references and standard-roll configuration. */
(function () {
  'use strict';

  const root = document.querySelector('[data-complete-room-modal]');
  if (!root) return;

  const $ = (selector, scope = root) => scope.querySelector(selector);
  const $$ = (selector, scope = root) => [...scope.querySelectorAll(selector)];
  const dialog = $('.complete-room__dialog');
  const paletteEl = $('[data-complete-room-palette]');
  const tonesEl = $('[data-complete-room-tones]');
  const toneOptionsEl = $('[data-complete-room-tone-options]');
  const statusEl = $('[data-complete-room-status]');
  const paintResultsEl = $('[data-complete-room-paint-results]');
  const selectedChipEl = $('[data-complete-room-selected-chip]');
  const roomColorEl = $('[data-complete-room-room-color]');
  const roomSceneEl = $('[data-complete-room-room-scene]');
  const roomPreviewTitleEl = $('[data-complete-room-preview-title]');
  const roomPreviewCaptionEl = $('[data-complete-room-preview-caption]');
  const roomSideWalls = $$('.complete-room__room-wall--left, .complete-room__room-wall--right');
  const roomCenterWall = $('.complete-room__room-wall--center');
  const previewEl = $('[data-complete-room-preview]');
  const printProofEl = $('[data-complete-room-print-proof]');
  const printProofSquareEl = $('[data-complete-room-print-proof-square]');
  const printProofLabelEl = $('[data-complete-room-pattern-label]');
  const proofModalEl = $('[data-complete-room-proof-modal]');
  const proofModalSquareEl = $('[data-complete-room-proof-modal-square]');
  const proofModalLabelEl = $('[data-complete-room-proof-modal-label]');
  const materialEl = $('[data-complete-room-material]');
  const materialButtons = $$('[data-complete-room-material-option]');
  const widthEl = $('[data-complete-room-width]');
  const heightEl = $('[data-complete-room-height]');
  const recommendationEl = $('[data-complete-room-recommendation]');
  const addButton = $('[data-complete-room-add]');
  const addPriceEl = $('[data-complete-room-add-price]');
  const sampleButton = $('[data-complete-room-sample]');
  const sampleMaterialEl = $('[data-complete-room-sample-material]');
  const samplePriceEl = $('[data-complete-room-sample-price]');
  const unitLabels = $$('[data-complete-room-unit-label]');
  const galleryPalettes = [...document.querySelectorAll('[data-complete-room-gallery-palette]')];
  const pricing = parseJson($('[data-complete-room-pricing]'), { materials: [] });
  const baseProduct = parseJson($('[data-complete-room-product]'), { configured: false, variant: null });
  const fallbackPalette = ['#e9dfce', '#c7a88c', '#748878', '#bd7964', '#7b6658', '#263b3a'];
  const patternRepeats = { solid: 0, vstripe: 20, cloud: 20, stripe: 20 };
  const MAX_WALL_WIDTH_IN = 3600;
  const MAX_WALL_HEIGHT_IN = 394;
  const MAX_STRIPS = 180;
  const MAX_ROLL_QUANTITY = 200;
  const state = {
    colors: [],
    baseColor: '',
    color: '',
    pattern: 'solid',
    unit: 'in',
    recommendation: null,
    paletteReady: false,
    lastFocus: null,
  };
  let paintCatalogPromise;
  let palettePromise;
  let inertedPageElements = [];
  let proofPreviousFocus = null;
  const trackedPaintColors = new Set();

  function parseJson(node, fallback) {
    try { return JSON.parse(node?.textContent || ''); } catch (_) { return fallback; }
  }

  function normalizeHex(value) {
    let hex = String(value || '').trim().replace(/^#/, '').toUpperCase();
    if (/^[0-9A-F]{3}$/.test(hex)) hex = hex.split('').map((c) => c + c).join('');
    return /^[0-9A-F]{6}$/.test(hex) ? `#${hex}` : '';
  }

  function hexToRgb(hex) {
    const clean = normalizeHex(hex).slice(1);
    return { r: parseInt(clean.slice(0, 2), 16), g: parseInt(clean.slice(2, 4), 16), b: parseInt(clean.slice(4, 6), 16) };
  }

  function rgbToHex(r, g, b) {
    return `#${[r, g, b].map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, '0')).join('')}`.toUpperCase();
  }

  function mixWithLight(hex, amount) {
    const color = hexToRgb(hex);
    const light = hexToRgb('#F7F4ED');
    return rgbToHex(
      color.r + ((light.r - color.r) * amount),
      color.g + ((light.g - color.g) * amount),
      color.b + ((light.b - color.b) * amount),
    );
  }

  function contrastColor(hex) {
    const color = hexToRgb(hex);
    const luminance = ((color.r * 299) + (color.g * 587) + (color.b * 114)) / 1000;
    return luminance < 142 ? '#FFFFFF' : '#14213D';
  }

  function rgbToLab(r, g, b) {
    const pivot = (v) => {
      v /= 255;
      return v > .04045 ? Math.pow((v + .055) / 1.055, 2.4) : v / 12.92;
    };
    r = pivot(r); g = pivot(g); b = pivot(b);
    let x = (r * .4124 + g * .3576 + b * .1805) / .95047;
    let y = (r * .2126 + g * .7152 + b * .0722);
    let z = (r * .0193 + g * .1192 + b * .9505) / 1.08883;
    const f = (v) => v > .008856 ? Math.cbrt(v) : (7.787 * v) + (16 / 116);
    x = f(x); y = f(y); z = f(z);
    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
  }

  function hexToLab(hex) {
    const rgb = hexToRgb(hex);
    return rgbToLab(rgb.r, rgb.g, rgb.b);
  }

  function deltaE(a, b) {
    return Math.hypot(a[0] - b[0], a[1] - b[1], a[2] - b[2]);
  }

  function imagePalette(url) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.decoding = 'async';
      image.onload = () => {
        try {
          const canvas = document.createElement('canvas');
          const size = 96;
          canvas.width = size; canvas.height = size;
          const context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(image, 0, 0, size, size);
          const pixels = context.getImageData(0, 0, size, size).data;
          const buckets = new Map();
          for (let i = 0; i < pixels.length; i += 16) {
            const alpha = pixels[i + 3];
            if (alpha < 210) continue;
            const r = pixels[i], g = pixels[i + 1], b = pixels[i + 2];
            const light = (Math.max(r, g, b) + Math.min(r, g, b)) / 2;
            if (light < 12 || light > 248) continue;
            const qr = Math.round(r / 20) * 20;
            const qg = Math.round(g / 20) * 20;
            const qb = Math.round(b / 20) * 20;
            const key = `${qr},${qg},${qb}`;
            const item = buckets.get(key) || { r: 0, g: 0, b: 0, count: 0 };
            item.r += r; item.g += g; item.b += b; item.count += 1;
            buckets.set(key, item);
          }
          const candidates = [...buckets.values()]
            .filter((item) => item.count > 1)
            .map((item) => {
              const hex = rgbToHex(item.r / item.count, item.g / item.count, item.b / item.count);
              return { hex, count: item.count, lab: hexToLab(hex) };
            })
            .sort((a, b) => b.count - a.count)
            .slice(0, 120);
          const selected = [];
          [15, 10, 6].some((minimumDistance) => {
            candidates.forEach((candidate) => {
              if (selected.length >= 6) return;
              if (!selected.some((color) => deltaE(color.lab, candidate.lab) < minimumDistance)) selected.push(candidate);
            });
            return selected.length >= 6;
          });
          const colors = selected.slice(0, 6).map((item) => item.hex);
          resolve(colors.length >= 3 ? colors : fallbackPalette);
        } catch (error) { reject(error); }
      };
      image.onerror = reject;
      image.src = url;
    });
  }

  async function ensurePalette() {
    if (state.paletteReady) return state.colors;
    if (!palettePromise) {
      palettePromise = imagePalette(root.dataset.sourcePaletteImage || root.dataset.sourceImage)
        .catch(() => fallbackPalette)
        .then((colors) => {
          state.colors = [...colors, ...fallbackPalette].filter((value, index, list) => list.indexOf(value) === index).slice(0, 6);
          state.paletteReady = true;
          renderPalette();
          renderGalleryPalettes(state.colors);
          statusEl.textContent = '6 design colors ready';
          statusEl.classList.add('is-ready');
          return state.colors;
        });
    }
    return palettePromise;
  }

  function renderPalette() {
    paletteEl.innerHTML = '';
    state.colors.forEach((hex, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.style.setProperty('--cr-color', hex);
      button.dataset.completeRoomColor = hex;
      button.setAttribute('aria-label', `Select color ${hex}`);
      button.innerHTML = `<span>${hex}</span>`;
      if (index === 0) button.classList.add('is-active', 'is-base-active');
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', () => selectBaseColor(hex, button, true));
      paletteEl.appendChild(button);
    });
    selectBaseColor(state.colors[0], paletteEl.firstElementChild, false);
  }

  function renderGalleryPalettes(colors) {
    galleryPalettes.forEach((palette) => {
      [...palette.querySelectorAll('i')].forEach((swatch, index) => {
        const color = colors[index];
        if (color) swatch.style.setProperty('--cr-gallery-color', color);
      });
      palette.classList.remove('is-loading');
    });
  }

  function renderToneVariants(baseHex) {
    if (!tonesEl || !toneOptionsEl) return;
    toneOptionsEl.innerHTML = '';
    [0.22, 0.4, 0.58].forEach((amount, index) => {
      const hex = mixWithLight(baseHex, amount);
      const button = document.createElement('button');
      button.type = 'button';
      button.style.setProperty('--cr-color', hex);
      button.dataset.completeRoomColor = hex;
      button.setAttribute('aria-label', `Select lighter tone ${index + 1}, ${hex}`);
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = `<i aria-hidden="true"></i><span>${hex}</span>`;
      button.addEventListener('click', () => selectColor(hex, button, true));
      toneOptionsEl.appendChild(button);
    });
    tonesEl.classList.remove('is-loading');
    tonesEl.hidden = false;
  }

  function selectBaseColor(hex, button, userInitiated = false) {
    state.baseColor = normalizeHex(hex) || fallbackPalette[0];
    $$('[data-complete-room-palette] [data-complete-room-color]').forEach((item) => {
      item.classList.toggle('is-base-active', item === button);
    });
    renderToneVariants(state.baseColor);
    selectColor(state.baseColor, button, userInitiated);
  }

  function selectColor(hex, button, userInitiated = false) {
    state.color = normalizeHex(hex) || fallbackPalette[0];
    $$('[data-complete-room-color]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    root.style.setProperty('--cr-color', state.color);
    selectedChipEl.style.setProperty('--cr-color', state.color);
    previewEl?.style.setProperty('--cr-color', state.color);
    if (roomColorEl) {
      roomColorEl.textContent = state.color;
      roomColorEl.style.color = contrastColor(state.color);
    }
    updateRoomPreview();
    $$('[data-complete-room-pattern]').forEach((item) => item.style.setProperty('--cr-color', state.color));
    if ($('[data-complete-room-panel="paint"]')?.classList.contains('is-active')) renderPaintMatches({ track: userInitiated });
    renderRecommendation();
    renderSampleButton();
  }

  async function loadPaintCatalog() {
    if (!paintCatalogPromise) {
      paintCatalogPromise = fetch(root.dataset.paintCatalog, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Paint reference catalog is unavailable.');
          return response.json();
        })
        .then((data) => {
          const prepare = (rows) => (Array.isArray(rows) ? rows : []).map(([code, hex]) => {
            const normalized = normalizeHex(hex);
            return normalized ? { code: String(code), hex: normalized, lab: hexToLab(normalized) } : null;
          }).filter(Boolean);
          return { a: prepare(data?.sets?.a), b: prepare(data?.sets?.b) };
        })
        .catch((error) => {
          paintCatalogPromise = undefined;
          throw error;
        });
    }
    return paintCatalogPromise;
  }

  function nearestPaint(targetLab, rows) {
    let best = null;
    rows.forEach((row) => {
      const distance = deltaE(targetLab, row.lab);
      if (!best || distance < best.distance) best = { ...row, distance };
    });
    return best;
  }

  function readableCode(code) {
    return String(code).replace(/^SW(?=\d)/i, 'SW ');
  }

  async function renderPaintMatches({ track = false } = {}) {
    if (!state.color) return;
    const colorAtRequest = state.color;
    paintResultsEl.innerHTML = '<p class="complete-room__muted">Matching the closest references…</p>';
    try {
      const catalog = await loadPaintCatalog();
      if (colorAtRequest !== state.color) return;
      const lab = hexToLab(state.color);
      const matches = [nearestPaint(lab, catalog.a), nearestPaint(lab, catalog.b)].filter(Boolean);
      paintResultsEl.innerHTML = matches.map((match, index) => `
        <article class="complete-room__paint-code" style="--cr-match:${match.hex}">
          <i aria-hidden="true"></i>
          <div><span>Reference ${index === 0 ? 'A' : 'B'}</span><strong>${escapeHtml(readableCode(match.code))}</strong></div>
          <button type="button" class="complete-room__copy" data-copy-code="${escapeHtml(readableCode(match.code))}">Copy</button>
        </article>`).join('');
      const paintPanelIsActive = !root.hidden && $('[data-complete-room-panel="paint"]')?.classList.contains('is-active');
      if (track && paintPanelIsActive && !trackedPaintColors.has(state.color)) {
        trackedPaintColors.add(state.color);
        window.MurallsFunnel?.activate?.('complete_room', undefined, 'paint');
        window.MurallsFunnel?.send?.('complete_room', 'searched', { mode: 'paint', productId: root.dataset.sourceProductId, productHandle: root.dataset.sourceProductHandle });
      }
    } catch (_) {
      paintResultsEl.innerHTML = '<p class="complete-room__muted">Reference codes could not be loaded. Please try again.</p>';
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[char]));
  }

  function updateRoomPreview(mode = roomSceneEl?.dataset.completeRoomPreviewMode || 'print') {
    const printMode = mode === 'print';
    const designType = root.dataset.sourceMode === 'mural' ? 'mural' : 'wallpaper';
    if (roomSceneEl) {
      roomSceneEl.dataset.completeRoomPreviewMode = printMode ? 'print' : 'paint';
      roomSceneEl.setAttribute('aria-label', printMode
        ? `Current ${designType} in the center with coordinating wallpaper on both sides`
        : `Current ${designType} in the center with ${state.color} paint on both sides`);
    }
    roomSideWalls.forEach((wall) => {
      wall.dataset.sideLabel = printMode ? 'Wallpaper · included' : 'Paint reference';
      wall.dataset.mobileLabel = printMode ? 'Included' : 'Paint';
    });
    if (roomCenterWall) {
      roomCenterWall.dataset.centerLabel = designType === 'mural'
        ? 'Mural · not included'
        : 'Source wallpaper · not included';
      roomCenterWall.dataset.mobileLabel = 'Not included';
    }
    if (roomPreviewTitleEl) roomPreviewTitleEl.textContent = printMode
      ? 'See coordinating wallpaper beside this design'
      : 'See the selected paint color beside this design';
    if (roomPreviewCaptionEl) roomPreviewCaptionEl.textContent = printMode
      ? 'Only the coordinating wallpaper on the side walls is included. The center design is shown for reference and is not included.'
      : 'The center design and paint are shown for color reference only. Paint is not sold by Muralls.';
  }

  function activateTab(name, userInitiated = false) {
    $$('[data-complete-room-tab]').forEach((tab) => {
      const active = tab.dataset.completeRoomTab === name;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    $$('[data-complete-room-panel]').forEach((panel) => {
      const active = panel.dataset.completeRoomPanel === name;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    updateRoomPreview(name);
    if (name === 'paint') {
      if (userInitiated) ensurePalette().then(() => {
        if (!root.hidden && $('[data-complete-room-panel="paint"]')?.classList.contains('is-active')) {
          renderPaintMatches({ track: true });
        }
      });
      else renderPaintMatches();
    }
  }

  function setPattern(pattern) {
    state.pattern = pattern;
    $$('[data-complete-room-pattern]').forEach((button) => {
      const active = button.dataset.completeRoomPattern === pattern;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.dataset.crPattern = button.dataset.completeRoomPattern;
    });
    if (previewEl) previewEl.dataset.crPattern = pattern;
    if (roomSceneEl) roomSceneEl.dataset.crPattern = pattern;
    if (printProofEl) printProofEl.dataset.crPattern = pattern;
    if (proofModalSquareEl) proofModalSquareEl.dataset.crPattern = pattern;
    if (printProofLabelEl) printProofLabelEl.textContent = patternLabel(pattern);
    if (proofModalLabelEl) proofModalLabelEl.textContent = patternLabel(pattern);
    if (printProofSquareEl) {
      printProofSquareEl.setAttribute('aria-label', `Open ${patternLabel(pattern)} 20 by 20 inch print preview`);
    }
    renderRecommendation();
  }

  function setMaterial(materialId) {
    if (!materialEl) return;
    const available = pricing.materials.some((item) => item.id === materialId);
    const nextId = available ? materialId : pricing.materials[0]?.id || materialEl.value;
    materialEl.value = nextId;
    materialButtons.forEach((button) => {
      const active = button.dataset.completeRoomMaterialOption === nextId;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-checked', String(active));
    });
    renderSampleButton();
    renderRecommendation();
  }

  function setUnit(unit, preserveValues = true) {
    const oldUnit = state.unit;
    let width = Number(widthEl.value || 0);
    let height = Number(heightEl.value || 0);
    if (preserveValues && oldUnit !== unit) {
      const toInches = (value, source) => source === 'cm' ? value / 2.54 : source === 'ft' ? value * 12 : value;
      const fromInches = (value, target) => target === 'cm' ? value * 2.54 : target === 'ft' ? value / 12 : value;
      if (Number.isFinite(width) && width > 0) {
        width = fromInches(toInches(width, oldUnit), unit);
        widthEl.value = formatDimension(width);
      }
      if (Number.isFinite(height) && height > 0) {
        height = fromInches(toInches(height, oldUnit), unit);
        heightEl.value = formatDimension(height);
      }
    }
    state.unit = unit;
    $$('[data-unit]', $('[data-complete-room-unit-switch]')).forEach((button) => {
      const active = button.dataset.unit === unit;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    unitLabels.forEach((label) => { label.textContent = unit; });
    renderRecommendation();
  }

  function formatDimension(value) {
    return Math.round(value * 10) / 10;
  }

  function dimensionsInInches() {
    const convert = (value) => state.unit === 'cm' ? value / 2.54 : state.unit === 'ft' ? value * 12 : value;
    return { width: convert(Number(widthEl.value || 0)), height: convert(Number(heightEl.value || 0)) };
  }

  function lengthFromSize(size) {
    const id = String(size.id || '').match(/(\d+)$/);
    if (id) return Number(id[1]);
    const label = String(size.label || '').match(/x\s*(\d+)/i);
    return label ? Number(label[1]) : 0;
  }

  function stripsPerRoll(rollLength, stripLength, repeat) {
    if (![rollLength, stripLength, repeat].every(Number.isFinite) || rollLength <= 0 || stripLength <= 0 || stripLength > rollLength || repeat < 0) return 0;
    if (repeat === 0) return Math.max(0, Math.floor((rollLength + 1e-7) / stripLength));
    let count = 0;
    let position = 0;
    const safeLimit = Math.ceil(rollLength / repeat) + 2;
    while (count < safeLimit) {
      const start = count === 0 ? 0 : Math.ceil((position - 1e-7) / repeat) * repeat;
      if (start + stripLength > rollLength + 1e-7) break;
      position = start + stripLength;
      count += 1;
    }
    return count;
  }

  function rollsForStrips(rollLength, stripCount, stripLength, repeat) {
    if (!Number.isSafeInteger(stripCount) || stripCount < 1 || stripCount > MAX_STRIPS) return Infinity;
    const capacity = stripsPerRoll(rollLength, stripLength, repeat);
    return capacity > 0 ? Math.ceil(stripCount / capacity) : Infinity;
  }

  function calculateRecommendation() {
    const wall = dimensionsInInches();
    if (!(wall.width > 0) || !(wall.height > 0)) return null;
    if (!Number.isFinite(wall.width) || !Number.isFinite(wall.height)) return { error: 'Enter valid finite wall dimensions.' };
    if (wall.width > MAX_WALL_WIDTH_IN || wall.height > MAX_WALL_HEIGHT_IN) {
      return { error: 'This wall is outside the online roll calculator limits. Please contact us for a custom quantity review.' };
    }
    const material = pricing.materials.find((item) => item.id === materialEl.value) || pricing.materials[0];
    if (!material) return null;
    const strips = Math.ceil(wall.width / 20);
    if (!Number.isSafeInteger(strips) || strips < 1 || strips > MAX_STRIPS) {
      return { error: 'This wall needs a custom quantity review. Please contact us for help.' };
    }
    const stripLength = wall.height + 2;
    const repeat = patternRepeats[state.pattern] ?? 0;
    let best = null;
    let fittingSizeFound = false;
    let quantityLimitExceeded = false;
    material.sizes.forEach((size) => {
      const rollLength = lengthFromSize(size);
      const quantity = rollsForStrips(rollLength, strips, stripLength, repeat);
      if (!Number.isFinite(quantity) || quantity < 1) return;
      fittingSizeFound = true;
      if (quantity > MAX_ROLL_QUANTITY) {
        quantityLimitExceeded = true;
        return;
      }
      const matrixTotal = Number(size.price || 0) * quantity;
      const candidate = { material, size, rollLength, quantity, strips, stripLength, repeat, matrixTotal, wall };
      if (!best || matrixTotal < best.matrixTotal || (matrixTotal === best.matrixTotal && quantity < best.quantity)) best = candidate;
    });
    if (best) return best;
    if (!fittingSizeFound) return { error: 'This wall is taller than our longest standard roll. Coordinating colors are currently sold only as standard wallpaper rolls.' };
    if (quantityLimitExceeded) return { error: 'This wall needs more rolls than the online order limit. Please contact us for a custom quantity review.' };
    return { error: 'No available roll option could be calculated for this wall.' };
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: root.dataset.currencyCode || 'USD', maximumFractionDigits: 2,
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `${root.dataset.currencySymbol || '$'}${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function currentCurrencyRate() {
    const runtimeRate = Number(window.Shopify?.currency?.rate);
    if (Number.isFinite(runtimeRate) && runtimeRate > 0) return runtimeRate;
    const fallbackRate = Number(root.dataset.currencyRate);
    return Number.isFinite(fallbackRate) && fallbackRate > 0 ? fallbackRate : 1;
  }

  function selectedMaterial() {
    return pricing.materials.find((item) => item.id === materialEl?.value) || pricing.materials[0] || null;
  }

  function samplePrice() {
    const usdCents = Number(sampleButton?.dataset.samplePriceUsd || 600);
    return {
      usdCents: Number.isFinite(usdCents) && usdCents > 0 ? Math.round(usdCents) : 600,
      cents: Math.round((Number.isFinite(usdCents) && usdCents > 0 ? usdCents : 600) * currentCurrencyRate()),
    };
  }

  function renderSampleButton() {
    if (!sampleButton) return;
    const material = selectedMaterial();
    const price = samplePrice();
    if (sampleMaterialEl) sampleMaterialEl.textContent = material?.label || material?.id || 'Wallpaper';
    if (samplePriceEl) samplePriceEl.textContent = formatMoney(price.cents);
    sampleButton.disabled = !(material && state.color && baseProduct.configured && baseProduct.variant?.available);
  }

  function renderRecommendation() {
    const result = calculateRecommendation();
    state.recommendation = result;
    recommendationEl.classList.remove('is-error');
    addButton.disabled = true;
    addPriceEl.textContent = '';
    if (!result) {
      recommendationEl.innerHTML = '<p>Enter your wall dimensions to calculate standard rolls.</p>';
      return;
    }
    if (result.error) {
      recommendationEl.classList.add('is-error');
      recommendationEl.innerHTML = `<p>${escapeHtml(result.error)}</p>`;
      return;
    }
    const unitPriceUsd = Math.round(Number(result.size.price || 0));
    const unitPrice = Math.round(unitPriceUsd * currentCurrencyRate());
    const total = unitPrice * result.quantity;
    result.unitPriceUsd = unitPriceUsd;
    result.unitPrice = unitPrice;
    result.total = total;
    recommendationEl.innerHTML = `
      <div class="complete-room__roll-result">
        <div><span>Recommended</span><strong>${result.quantity} × 20″ × ${result.rollLength}″ rolls</strong></div>
        <strong>${formatMoney(total)}</strong>
      </div>`;
    addPriceEl.textContent = formatMoney(total);
    addButton.disabled = !(baseProduct.configured && baseProduct.variant?.available);
  }

  function restoreWallSize() {
    const saved = window.MurallsWallSize?.get?.();
    if (!saved) return;
    const preferred = saved.unit === 'cm' ? 'cm' : saved.unit === 'ft' || saved.unit === 'ftin' ? 'ft' : 'in';
    state.unit = preferred;
    const widthIn = saved.widthCm / 2.54;
    const heightIn = saved.heightCm / 2.54;
    widthEl.value = formatDimension(preferred === 'cm' ? saved.widthCm : preferred === 'ft' ? widthIn / 12 : widthIn);
    heightEl.value = formatDimension(preferred === 'cm' ? saved.heightCm : preferred === 'ft' ? heightIn / 12 : heightIn);
    setUnit(preferred, false);
  }

  function saveWallSize() {
    const wall = dimensionsInInches();
    if (wall.width > 0 && wall.height > 0) window.MurallsWallSize?.save?.(wall.width * 2.54, wall.height * 2.54, state.unit);
  }

  function patternLabel(pattern) {
    return ({ solid: 'Solid', vstripe: '3⅓″ Vertical Stripe', cloud: 'Cloud Wash', stripe: '3⅓″ Horizontal Stripe' })[pattern] || pattern;
  }

  function patternAsset(pattern) {
    if (pattern === 'solid') return 'solid';
    if (pattern === 'vstripe') return 'complete-room-pattern-vertical-stripe-v2.svg';
    if (pattern === 'cloud') return 'complete-room-pattern-cloud-eps.webp';
    if (pattern === 'stripe') return 'complete-room-pattern-horizontal-stripe-v3.svg';
    return `complete-room-pattern-${pattern}.svg`;
  }

  function visibleSizeLabel(result) {
    const preferred = root.dataset.usesImperial === 'true' ? result.size.label : result.size.label_cm;
    return preferred || result.size.label || `1 Roll 20''x${result.rollLength}''`;
  }

  async function addToCart() {
    const result = state.recommendation;
    if (!result || result.error || !baseProduct.variant?.available || !state.color) return;
    const variantId = String(baseProduct.variant.id || '');
    if (!/^\d+$/.test(variantId)) return;
    addButton.disabled = true;
    const original = addButton.querySelector('span').textContent;
    addButton.querySelector('span').textContent = 'Adding…';
    const configurationId = window.crypto?.randomUUID?.() || `cr-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const wall = dimensionsInInches();
    const properties = {
      'Design color': state.color,
      'Pattern': patternLabel(state.pattern),
      'Material': result.material.label || result.material.id,
      'Wall size': `${formatDimension(widthEl.value)} × ${formatDimension(heightEl.value)} ${state.unit}`,
      'Size': visibleSizeLabel(result),
      'Source design': root.dataset.sourceTitle,
      '_Material code': result.material.id,
      '_Size code': result.size.id,
      '_Calculated price': formatMoney(result.unitPrice),
      '_custom_price': String(result.unitPrice),
      '_custom_price_usd': String(result.unitPriceUsd),
      '_complete_room': 'yes',
      '_complete_room_color': state.color,
      '_complete_room_pattern': state.pattern,
      '_complete_room_material': result.material.id,
      '_complete_room_roll_length': String(result.rollLength),
      '_complete_room_wall_width_in': wall.width.toFixed(2),
      '_complete_room_wall_height_in': wall.height.toFixed(2),
      '_complete_room_recipe_version': 'cr-v4-pattern-repeat',
      '_complete_room_pattern_asset': patternAsset(state.pattern),
      '_complete_room_pattern_repeat_in': String(result.repeat),
      '_complete_room_strip_count': String(result.strips),
      '_complete_room_strip_length_in': Number(result.stripLength).toFixed(2),
      '_configuration_id': configurationId,
      '_source_product_id': root.dataset.sourceProductId,
      '_source_product_handle': root.dataset.sourceProductHandle,
      '_source_product_type': root.dataset.sourceProductType,
      '_source_blank_image': root.dataset.sourceImage,
    };
    window.MurallsFunnel?.activate?.('complete_room', undefined, 'printed');
    window.MurallsFunnel?.send?.('complete_room', 'searched', { mode: 'printed', productId: root.dataset.sourceProductId, productHandle: root.dataset.sourceProductHandle });
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: result.quantity, properties }] }),
        signal: controller.signal,
      });
      if (!response.ok) throw new Error(await response.text());
      window.location.href = window.routes?.cart_url || '/cart';
    } catch (error) {
      console.error('[complete-room] add failed', error);
      addButton.querySelector('span').textContent = error?.name === 'AbortError' ? 'Timed out — try again' : 'Try again';
      addButton.disabled = false;
      setTimeout(() => { addButton.querySelector('span').textContent = original; }, 1800);
    } finally {
      window.clearTimeout(timeout);
    }
  }

  async function addSampleToCart(materialId) {
    const material = pricing.materials.find((item) => item.id === materialId) || selectedMaterial();
    if (!sampleButton || !material || !state.color || !baseProduct.configured || !baseProduct.variant?.available) return;
    const variantId = String(baseProduct.variant.id || '');
    if (!/^\d+$/.test(variantId)) return;
    if (materialEl?.value !== material.id) setMaterial(material.id);

    const price = samplePrice();
    const label = material.label || material.id;
    const original = sampleButton.innerHTML;
    sampleButton.disabled = true;
    sampleButton.textContent = 'Adding sample…';

    const configurationId = window.crypto?.randomUUID?.() || `cr-sample-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const properties = {
      'Design color': state.color,
      'Pattern': patternLabel(state.pattern),
      'Material': label,
      'Size': 'Sample (9 × 20 in)',
      'Sample type': 'Coordinating wallpaper',
      'Source design': root.dataset.sourceTitle,
      'Calculated price': formatMoney(price.cents),
      'Material code': material.id,
      'Size code': 'SAMPLE',
      '_custom_price': String(price.cents),
      '_custom_price_usd': String(price.usdCents),
      '_is_sample': 'yes',
      '_complete_room': 'yes',
      '_complete_room_sample': 'yes',
      '_complete_room_color': state.color,
      '_complete_room_pattern': state.pattern,
      '_complete_room_material': material.id,
      '_complete_room_recipe_version': 'cr-v4-pattern-repeat',
      '_complete_room_pattern_asset': patternAsset(state.pattern),
      '_complete_room_pattern_repeat_in': String(patternRepeats[state.pattern] ?? 0),
      '_configuration_id': configurationId,
      '_source_product_id': root.dataset.sourceProductId,
      '_source_product_handle': root.dataset.sourceProductHandle,
      '_source_product_type': root.dataset.sourceProductType,
      '_source_blank_image': root.dataset.sourceImage,
    };

    window.MurallsFunnel?.activate?.('complete_room', undefined, 'sample');
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] }),
        signal: controller.signal,
      });
      if (!response.ok) throw new Error(await response.text());
      window.location.href = window.routes?.cart_url || '/cart';
    } catch (error) {
      console.error('[complete-room] sample add failed', error);
      sampleButton.textContent = error?.name === 'AbortError' ? 'Timed out — try again' : 'Try again';
      setTimeout(() => {
        sampleButton.innerHTML = original;
        renderSampleButton();
      }, 1800);
    } finally {
      window.clearTimeout(timeout);
    }
  }

  function openSampleDialog() {
    const material = selectedMaterial();
    if (!sampleButton || !material || !state.color || !baseProduct.configured || !baseProduct.variant?.available) return;
    if (!window.DKSampleConfirm) {
      addSampleToCart(material.id);
      return;
    }
    window.DKSampleConfirm.open({
      materials: pricing.materials.map((item, index) => ({
        id: item.id,
        label: item.label || item.id,
        description: item.description || '',
        popular: index === 0,
      })),
      currentId: material.id,
      priceText: formatMoney(samplePrice().cents),
      onSelect: (id) => setMaterial(id),
      onConfirm: (id) => {
        const confirmedId = id || selectedMaterial()?.id;
        if (confirmedId) setMaterial(confirmedId);
        addSampleToCart(confirmedId);
      },
    });
  }

  function setPageInert(active) {
    if (active) {
      inertedPageElements = [...document.body.children].filter((element) => element !== root && !element.inert);
      inertedPageElements.forEach((element) => { element.inert = true; });
      return;
    }
    inertedPageElements.forEach((element) => { element.inert = false; });
    inertedPageElements = [];
  }

  function openModal(trigger) {
    state.lastFocus = trigger || document.activeElement;
    root.hidden = false;
    document.body.classList.add('complete-room-open');
    setPageInert(true);
    dialog.focus({ preventScroll: true });
    ensurePalette().then(() => {
      if (roomSceneEl && !roomSceneEl.style.getPropertyValue('--cr-room-art')) {
        const sourceImage = String(root.dataset.sourceImage || '').replace(/["\\]/g, '\\$&');
        if (sourceImage) roomSceneEl.style.setProperty('--cr-room-art', `url("${sourceImage}")`);
      }
    });
    restoreWallSize();
    activateTab('print');
    setPattern(state.pattern);
    renderSampleButton();
    window.MurallsFunnel?.activate?.('complete_room');
  }

  function openProofModal() {
    if (!proofModalEl) return;
    proofPreviousFocus = document.activeElement;
    proofModalEl.hidden = false;
    $('[data-complete-room-proof-close]', proofModalEl)?.focus({ preventScroll: true });
  }

  function closeProofModal() {
    if (!proofModalEl || proofModalEl.hidden) return;
    proofModalEl.hidden = true;
    proofPreviousFocus?.focus?.({ preventScroll: true });
    proofPreviousFocus = null;
  }

  function closeModal() {
    closeProofModal();
    root.hidden = true;
    document.body.classList.remove('complete-room-open');
    setPageInert(false);
    state.lastFocus?.focus?.({ preventScroll: true });
  }

  if (galleryPalettes.length) {
    const requestGalleryPalette = () => { ensurePalette(); };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        requestGalleryPalette();
      }, { rootMargin: '240px' });
      galleryPalettes.forEach((palette) => observer.observe(palette));
    }

    const scheduleGalleryPalette = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(requestGalleryPalette, { timeout: 2500 });
      } else {
        window.setTimeout(requestGalleryPalette, 1200);
      }
    };
    if (document.readyState === 'complete') scheduleGalleryPalette();
    else window.addEventListener('load', scheduleGalleryPalette, { once: true });
  }

  // Product media can be re-rendered after this script initializes. Delegate
  // the opener so replacement gallery controls keep working as well.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const trigger = target?.closest('[data-complete-room-open]');
    if (trigger) openModal(trigger);
  });
  $$('[data-complete-room-close]').forEach((trigger) => trigger.addEventListener('click', closeModal));
  const tabs = $$('[data-complete-room-tab]');
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activateTab(tab.dataset.completeRoomTab, true));
    tab.addEventListener('keydown', (event) => {
      let nextIndex = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;
      if (nextIndex === null) return;
      event.preventDefault();
      const nextTab = tabs[nextIndex];
      activateTab(nextTab.dataset.completeRoomTab, true);
      nextTab.focus();
    });
  });
  $$('[data-complete-room-pattern]').forEach((button) => button.addEventListener('click', () => setPattern(button.dataset.completeRoomPattern)));
  $('[data-complete-room-proof-open]')?.addEventListener('click', openProofModal);
  $$('[data-complete-room-proof-close]').forEach((button) => button.addEventListener('click', closeProofModal));
  materialButtons.forEach((button) => button.addEventListener('click', () => setMaterial(button.dataset.completeRoomMaterialOption)));
  $$('[data-unit]', $('[data-complete-room-unit-switch]')).forEach((button) => button.addEventListener('click', () => setUnit(button.dataset.unit)));
  [widthEl, heightEl].forEach((input) => input.addEventListener('input', () => { renderRecommendation(); saveWallSize(); }));
  materialEl.addEventListener('change', () => setMaterial(materialEl.value));
  addButton.addEventListener('click', addToCart);
  sampleButton?.addEventListener('click', openSampleDialog);
  paintResultsEl.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-code]');
    if (!button) return;
    try { await navigator.clipboard.writeText(button.dataset.copyCode); button.textContent = 'Copied'; }
    catch (_) { button.textContent = button.dataset.copyCode; }
    setTimeout(() => { button.textContent = 'Copy'; }, 1400);
  });
  document.addEventListener('keydown', (event) => {
    if (root.hidden) return;
    if (event.key === 'Escape') {
      if (proofModalEl && !proofModalEl.hidden) {
        closeProofModal();
        return;
      }
      closeModal();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusScope = proofModalEl && !proofModalEl.hidden ? proofModalEl : dialog;
    const focusable = [...focusScope.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.closest('[hidden]') && element.getClientRects().length > 0);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus({ preventScroll: true });
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog || !focusScope.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === dialog || !focusScope.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  setPattern('solid');
  setMaterial(materialEl.value);
  setUnit('in', false);
})();
